<template>
  <div class="course-list-tab" v-loading="loading">
    <!-- <div class="tab-header">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddCourse">
        为学员购买课程
      </el-button>
    </div> -->

    <el-table
      :data="courseList"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa', color: '#333' }"
    >
      <el-table-column type="index" label="序号" width="60" />
      <el-table-column prop="courseName" label="课程名称" min-width="180" />
      <el-table-column prop="wordCount" label="单词数量" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.wordCount || 0 }} 个</span>
        </template>
      </el-table-column>
      <el-table-column prop="progress" label="学习进度" min-width="150">
        <template slot-scope="scope">
          <el-progress
            :percentage="scope.row.progress || 0"
            :color="progressColor(scope.row.progress)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="learnedWords" label="已学单词" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.learnedWords || 0 }} / {{ scope.row.wordCount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="purchaseDate" label="购买日期" min-width="120" />
      <el-table-column prop="expireDate" label="到期日期" min-width="120">
        <template slot-scope="scope">
          <span :class="{ 'expire-soon': isExpireSoon(scope.row.expireDate) }">
            {{ scope.row.expireDate }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" min-width="80">
        <template slot-scope="scope">
          <el-tag :type="statusType(scope.row.status)" size="small">
            {{ statusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="handleExtend(scope.row)"
          >
            续期
          </el-button>
          <el-button
            type="text"
            size="small"
            style="color: #f56c6c"
            @click="handleRemove(scope.row)"
          >
            移除
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <el-empty v-if="!loading && courseList.length === 0" description="暂无购买课程" />

    <!-- 添加课程对话框 -->
    <add-course-dialog
      :visible.sync="showAddDialog"
      :student-id="studentId"
      @success="handleAddSuccess"
    />

    <!-- 续期对话框 -->
    <extend-course-dialog
      :visible.sync="showExtendDialog"
      :course-data="currentCourse"
      @success="handleExtendSuccess"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import AddCourseDialog from './AddCourseDialog.vue';
import ExtendCourseDialog from './ExtendCourseDialog.vue';

export default {
  name: 'CourseListTab',
  components: {
    AddCourseDialog,
    ExtendCourseDialog,
  },
  props: {
    studentId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      courseList: [],
      showAddDialog: false,
      showExtendDialog: false,
      currentCourse: null,
    };
  },
  created() {
    this.loadCourseList();
  },
  methods: {
    ...mapActions('student', ['fetchStudentCourses', 'removeStudentCourse']),

    /**
     * 加载课程列表
     */
    async loadCourseList() {
      this.loading = true;
      try {
        this.courseList = await this.fetchStudentCourses(this.studentId);
      } catch (error) {
        console.error('加载课程列表失败:', error);
        this.$message.error('加载课程列表失败');
      } finally {
        this.loading = false;
      }
    },

    /**
     * 添加课程
     */
    handleAddCourse() {
      this.showAddDialog = true;
    },

    /**
     * 续期
     */
    handleExtend(course) {
      this.currentCourse = { ...course };
      this.showExtendDialog = true;
    },

    /**
     * 移除课程
     */
    handleRemove(course) {
      this.$confirm(`确定要移除课程"${course.courseName}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          await this.removeStudentCourse({
            studentId: this.studentId,
            courseId: course.courseId,
          });
          this.$message.success('移除成功');
          this.loadCourseList();
        } catch (error) {
          console.error('移除课程失败:', error);
          this.$message.error('移除课程失败');
        }
      });
    },

    /**
     * 添加成功
     */
    handleAddSuccess() {
      this.showAddDialog = false;
      this.loadCourseList();
    },

    /**
     * 续期成功
     */
    handleExtendSuccess() {
      this.showExtendDialog = false;
      this.loadCourseList();
    },

    /**
     * 进度条颜色
     */
    progressColor(progress) {
      if (progress < 30) return '#f56c6c';
      if (progress < 70) return '#e6a23c';
      return '#67c23a';
    },

    /**
     * 判断是否即将过期
     */
    isExpireSoon(expireDate) {
      if (!expireDate) return false;
      const today = new Date();
      const expire = new Date(expireDate);
      const diff = expire - today;
      const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
      return days <= 7 && days >= 0;
    },

    /**
     * 状态类型
     */
    statusType(status) {
      const typeMap = {
        active: 'success',
        completed: 'info',
        inactive: 'warning',
        expired: 'danger',
      };
      return typeMap[status] || 'info';
    },

    /**
     * 状态文本
     */
    statusText(status) {
      const textMap = {
        active: '学习中',
        completed: '已完成',
        inactive: '未激活',
        expired: '已过期',
      };
      return textMap[status] || '未知';
    },
  },
};
</script>

<style scoped>
.course-list-tab {
  padding: 10px 0;
  min-height: 400px;
}

.tab-header {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.expire-soon {
  color: #f56c6c;
  font-weight: 600;
}
</style>
